import ProviderCampaignPublishers from './components/ProviderCampaignPublishers.js';
import connect from './connect';
import './assets/ProviderCampaignPublishers.css';

export default connect(ProviderCampaignPublishers);



// WEBPACK FOOTER //
// ./src/routes/ProviderCampaignPublishers/index.js